import React, { useEffect } from 'react';
import './Help.css';

const HelpPage = () => {
  useEffect(() => {
    document.title = 'Help | CVM Insights';
  }, []);

  return (
    <div>
      <header className="tvt-main__header">
        <div className="page-header-root">
          <h1 className="page-header__title">Contact</h1>
        </div>
      </header>
      <div className="help-page__body">
        Need help? Have a question? Want to provide feedback? Send us a message
        at{' '}
        <a href="mailto:insights-support@whipmedia.com">
          insights-support@whipmedia.com
        </a>{' '}
        and we will get back to you shortly.
      </div>
      <header className="tvt-main__header" style={{ 'margin-top': '50px' }}>
        <div className="page-header-root">
          <h1 className="page-header__title">Metric Glossary</h1>
        </div>
      </header>
      <iframe
        src="/metric_glossary.pdf"
        title="Metric Glossary"
        width="100%"
        height="1000px"
      />
    </div>
  );
};

export default HelpPage;
